import { render, staticRenderFns } from "./McForm.vue?vue&type=template&id=ef8dded6"
import script from "./McForm.vue?vue&type=script&lang=js"
export * from "./McForm.vue?vue&type=script&lang=js"
import style0 from "./McForm.vue?vue&type=style&index=0&id=ef8dded6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports